import Vue from "vue";

export class Validation {
  constructor(validation, input) {
    this.validation = validation;
    this.input = input;
  }

  validate() {
    let validationMessage = "";
    let error = false;

    if (this.validation.validation === "required") {
      if (this.input < 1) {
        validationMessage = "Eingabe notwendig";
        error = true;
      }
    }

    if (this.validation.validation === "email") {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(this.input).toLowerCase())) {
        validationMessage = "Ungültige Email";
        error = true;
      }
    }

    if (this.validation.validation === "length") {
      if (this.validation.type === "min") {
        validationMessage =
          "min. " + this.input.length + "/" + this.validation.value;
        if (this.input.length < this.validation.value) {
          error = true;
        }
      } else if (this.validation.type === "max") {
        validationMessage =
          "max. " + this.input.length + "/" + this.validation.value;
        if (this.input.length > this.validation.value) {
          error = true;
        }
      }
    }
    return { message: validationMessage, error };
  }
}
